export default {
  stockItemActivities: [],
  stockItemActivity: undefined,
};
